export const Permissions = Object.freeze({
    Security: Object.freeze({
        Users: 'SECURITY.USERS',
        Roles: 'SECURITY.ROLES',
        CompanyAccess: 'SECURITY.COMPANY_ACCESS',
        Licenses: 'SECURITY.LICENSES',
        Configuration: 'SECURITY.CONFIGURATION'
    }),
    Conciliation: Object.freeze({
        Extractions: 'CONCILIATION.EXTRACTIONS',
        NitGlMapping: 'CONCILIATION.NIT_GL_MAPPING',
        AccountMapping: 'CONCILIATION.ACCOUNT_MAPPING',
        ManualPosting: 'CONCILIATION.MANUAL_POSTING',
        Reports: 'CONCILIATION.REPORTS'
    }),
    Extractions: Object.freeze({
        Manual: 'EXTRACTIONS.MANUAL',
        ScheduledTasks: 'EXTRACTIONS.SCHEDULED_TASKS',
        Templates: 'EXTRACTIONS.TEMPLATES',
        ExecutionLogs: 'EXTRACTIONS.EXECUTION_LOGS'
    }),
    Reports: Object.freeze({ Dashboards: 'REPORTS.DASHBOARDS' }),
    DataManagement: Object.freeze({
        ApiConnection: 'DATA_MANAGEMENT.API_CONNECTION',
        Products: 'DATA_MANAGEMENT.PRODUCTS',
        Stores: 'DATA_MANAGEMENT.STORES',
        BacConnection: 'DATA_MANAGEMENT.BAC_CONNECTION',
        SapConnection: 'DATA_MANAGEMENT.SAP_CONNECTION'
    }),
    Management: Object.freeze({
        Companies: 'MANAGEMENT.COMPANIES',
        FinancialInstitutions: 'MANAGEMENT.FINANCIAL_INSTITUTIONS',
        FinancialAccounts: 'MANAGEMENT.FINANCIAL_ACCOUNTS',
        PaymentCards: 'MANAGEMENT.PAYMENT_CARDS'
    }),
    Collaboration: Object.freeze({
        MyDocuments: 'COLLABORATION.MY_DOCUMENTS',
        ChatFiles: 'COLLABORATION.CHAT_FILES',
        Chat: 'COLLABORATION.CHAT',
        DocuChat: 'COLLABORATION.DOCU_CHAT',
        MarcbiChat: 'COLLABORATION.MARCBI_CHAT',
        MarcbiCreative: 'COLLABORATION.MARCBI_CREATIVE',
        AdminNotifications: 'COLLABORATION.ADMIN_NOTIFICATIONS',
        Notifications: 'COLLABORATION.NOTIFICATIONS',
        News: 'COLLABORATION.NEWS'
    }),
    Support: Object.freeze({ Tickets: 'SUPPORT.TICKETS' }),
    Concur: Object.freeze({ Expenses: 'CONCUR.EXPENSES' })
});
